// A reaction on Jane's latest reply is the user's answer to it, so the server
// starts a reply (Assistant::ReactionReply) and says so with the
// X-Reaction-Reply-Started header, naming the conversation. The reaction went
// out as a fetch, which never reloads the page the way a composer send does —
// so nothing would otherwise wake the page's assistant-poll controller, and
// the reply would only appear on the next load. This raises
// "reactions:reply-started" for it to hear.
//
// On document, not the reacting element: picking an emoji closes the picker,
// which can release a chat re-render the poller was holding (see
// assistant_poll_controller.js) — by the time this response lands, the
// element that sent it may already have been replaced.
export function announceReactionReply(response) {
    const conversationId = Number(response?.headers?.get("X-Reaction-Reply-Started"))
    if (!conversationId) return

    document.dispatchEvent(new CustomEvent("reactions:reply-started", { detail: { conversationId } }))
}
